export const Alert = (props) => {
    const { message, title, level, className } = props;
    return (
        <div className={"border border-app-primary p-3 rounded-xl"}>
            {title && <h5 className="font-bold text-app-primary">{title}</h5>}
            {message && (
                <p className={"p-0 mb-0 italic ".concat(className)}>
                    {message}
                </p>
            )}
        </div>
    );
};
